import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'natural-orderby';
import { SingleSelect } from 'smartsuite-ui';
import { useLabelContext } from '../../shared/hooks/labelContext';

// eslint-disable-next-line complexity
function filterByDashboardViewAndWidget(option, searchText, dashboardLabels) {
    const searchTextToLowerCase = searchText.toLowerCase();

    const widgetLabel = option.label.toLowerCase();
    const widgetGroupingLabel = option.data.groupingLabel?.toLowerCase();
    const widgetViewKey = option.value.viewKey?.toLowerCase();
    const widgetViewLabel = dashboardLabels[widgetViewKey]?.toLowerCase();
    const widgetDashboardKey = option.value.dashboardKey?.toLowerCase();
    const widgetDashboardLabel = option.value.dashboardLabel?.toLowerCase();

    return (
        searchText === '' ||
        widgetLabel?.includes(searchTextToLowerCase) ||
        widgetGroupingLabel?.includes(searchTextToLowerCase) ||
        widgetViewKey?.includes(searchTextToLowerCase) ||
        widgetViewLabel?.includes(searchTextToLowerCase) ||
        widgetDashboardKey?.includes(searchTextToLowerCase) ||
        widgetDashboardLabel?.includes(searchTextToLowerCase)
    );
}

export default function DashboardViewWidgetSelect(props) {
    const { dashboardLabels } = useLabelContext();

    return (
        <SingleSelect
            label={dashboardLabels.widget}
            onChange={props.onChange}
            options={[
                {
                    label: dashboardLabels.quickLinks,
                    options: orderBy(props.systemPanels, 'textField'),
                },
                ...props.landingPageWidgetOptions,
            ]}
            textField="textField"
            valueField="valueField"
            value={props.selectedLandingPageWidget}
            filterOption={(option, searchText) =>
                filterByDashboardViewAndWidget(
                    option,
                    searchText,
                    dashboardLabels
                )
            }
        />
    );
}

DashboardViewWidgetSelect.propTypes = {
    landingPageWidgetOptions: PropTypes.instanceOf(Array).isRequired,
    onChange: PropTypes.func.isRequired,
    selectedLandingPageWidget: PropTypes.instanceOf(Object),
    systemPanels: PropTypes.instanceOf(Array).isRequired,
};
